// @flow
import React, { Component } from 'react';
import { loadScripts } from '../../../../utils/scripts';

type Props = {
    content: Object,
    options: {
        scripts: array,
        params: Object,
    },
};

const scripts = [
    {
        src: 'http://player.ooyala.com/static/v4/stable/latest/core.min.js',
        id: 'ooyala-core',
        type: 'script',
        async: false,
    },
    {
        src:
            'http://player.ooyala.com/static/v4/stable/latest/video-plugin/main_html5.min.js',
        id: 'ooyala-main',
        type: 'script',
        async: false,
    },
    {
        src:
            'http://player.ooyala.com/static/v4/stable/latest/skin-plugin/html5-skin.min.js',
        id: 'ooyala-skin',
        type: 'script',
        async: false,
    },
    {
        href:
            'http://player.ooyala.com/static/v4/stable/latest/skin-plugin/html5-skin.min.css',
        id: 'ooyala-css',
        type: 'stylesheet',
    },
];

export default class Ooyala extends Component<Props> {
    createVideoPlayer = (OO, pcode, player_id, embed_code) => {
        const customParam =
            this.props.options && this.props.options.params
                ? this.props.options.params
                : {};

        let playerParam = {
            pcode: pcode,
            playerBrandingId: player_id,
            skin: {
                config:
                    'http://player.ooyala.com/static/v4/stable/latest/skin-plugin/skin.json',
            },
            ...customParam,
        };

        OO.ready(() => {
            window.pp = OO.Player.create(
                `inplayer-ooyala-${player_id}`,
                embed_code,
                playerParam
            );
        });
    };

    componentDidMount() {
        const { player_id, pcode, embed_code } = this.props.content;
        const customScripts = this.props.options && this.props.options.scripts;

        if (customScripts)
            loadScripts(customScripts)
                .then(() => {
                    if (OO)
                        this.createVideoPlayer(
                            OO,
                            pcode,
                            player_id,
                            embed_code
                        );
                })
                .catch(error => {
                    console.error('Could not load ooyala scripts: ', error);
                });
        else
            loadScripts(scripts)
                .then(() => {
                    if (OO)
                        this.createVideoPlayer(
                            OO,
                            pcode,
                            player_id,
                            embed_code
                        );
                })
                .catch(error => {
                    console.error('Could not load ooyala scripts: ', error);
                });
    }

    componentWillUnmount() {
        scripts.forEach(s => {
            const e = document.getElementById(s.id);
            if (e) {
                e.outerHTML = '';
            }
        });
    }

    render() {
        const { player_id } = this.props.content;

        return <div id={`inplayer-ooyala-${player_id}`} />;
    }
}



// WEBPACK FOOTER //
// ./src/containers/Asset/ContentInjectors/Ovp/Ooyala.js